export default __webpack_public_path__ + "static/media/back-btn.056b5f46.svg";